<template>
  <div class="upload" v-if="!isEdit">
    <label class="upload-label" for="uploader">
      <p>add image</p>
      <svg class="camera-icon" viewBox="0 0 600 600">
        <use xlink:href="#camera-icon"  width="60px" height="60px"></use>
      </svg>
      <span class="size-limit">max image size 5MB</span>
    </label>
    <input
        accept="image/png,image/gif,image/jpeg"
        class="hide"
        id="uploader"
        name="uploader"
        ref="uploader"
        type="file"
        @change="validateImage">
  </div>

  <div class="upload" v-else>
    <div class="replace" @click="$refs.uploader.click()">replace</div>
    <input
        accept="image/png,image/gif,image/jpeg"
        class="hide"
        id="uploader"
        name="uploader"
        ref="uploader"
        type="file"
        @change="validateImage">
  </div>




</template>

<script>
import LogDateFormat from '../mixins/LogDateFormat'
  export default {
    props: {
      emptyInput: Boolean,
      isEdit: Boolean
    },

    name: 'Upload',

    data() {
      return {
        maxFileSize: 1024 * 1024 * 5, // 5 mb
        fileTypes: ['image/png','image/gif','image/jpeg']
      }
    },

    methods: {
      showErrorAndClearFile() {
        this.$refs.uploader.value = null
        this.$emit('showModal')
      },

      validateImage(event) {
        const file =  event.target.files[0],
              view = this

        let img = new Image()
        img.onload = function() {
          const validType = view.fileTypes.includes(file.type),
                validSize = file.size <= view.maxFileSize;

          if (validType && validSize) {
            view.$emit('previewImage', file, true)
            view.$emit('uploadImage')
          } else {
            view.showErrorAndClearFile()
          }
        }
        img.onerror = (e) => {
          view.showErrorAndClearFile()
        }
        img.src = URL.createObjectURL(file)
      }
    },

    watch: {
      emptyInput: function() {
        const $file = this.$refs.uploader
        $file.value = null
      }
    }
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.upload
  .upload-label
    align-items: center
    background: $primary-color
    border-radius: 32px
    color: #fff
    cursor: pointer
    display: inline-flex
    flex-direction: column
    height: 150px
    justify-content: space-between
    padding: 1rem
    width: 200px
    transition: background 0.25s ease-out

    &:hover
      background: $tertiary-color

  p
    color: #fff

  .size-limit
    font-size: .75rem
    opacity: .5

svg.camera-icon
  fill: #fff
  height: 60px
  width: 60px

.replace
  color: $negative-color
  cursor: pointer
  font-size: .9rem
  margin-top: .5rem
  &:hover
    color: $negative-hover


</style>
